import clsx from "clsx";
import React, { FC } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLayout } from "../../../core/LayoutProvider";
import { usePageData } from "../../../core/PageData";

const DefaultTitle: FC = () => {
  const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData();
  const { config, classes } = useLayout();
  const navigation = useNavigate();

  const handleBackButton = () => {
    if (Array.isArray(pageBreadcrumbs)) {
      pageBreadcrumbs.length > 1 && navigation(-1);
    }
  };

  return (
    <div
      id="kt_page_title"
      data-kt-swapper="false"
      data-kt-swapper-mode="prepend"
      data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
      className={clsx("page-title d-flex", classes.pageTitle.join(" "))}
    >
      {/* begin::Title */}
      {pageTitle && (
        <>
          <button
            style={{
              height: "30px",
              width: "30px",
              borderRadius: "50%",
              background: "rgba(231, 248, 240, 1)",
              border: "none",
            }}
            onClick={handleBackButton}
          >
            <svg
              width="8"
              height="12"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.97071 5.69149L6.49611 0.333408C6.84088 -0.000926943 7.5 0.201735 7.5 0.642081L7.5 11.3582C7.5 11.7986 6.84089 12.0013 6.49611 11.6669L0.970711 6.30884C0.787542 6.13121 0.787543 5.86911 0.97071 5.69149Z"
                fill="#12B76A"
              />
            </svg>
          </button>
          <h1
            className="d-flex align-items-center fw-semibold ms-3 m-0 me-2"
            style={{ color: "#1D2939", fontSize: "15px" }}
          >
            {pageTitle}
            {pageDescription &&
              config.pageTitle &&
              config.pageTitle.description && (
                <>
                  <span className="h-20px border-gray-200 border-start ms-3 mx-2"></span>
                  <small className="text-muted fs-7 fw-bold my-1 ms-1">
                    {pageDescription}
                  </small>
                </>
              )}
          </h1>
        </>
      )}
      {/* end::Title */}

      {pageBreadcrumbs &&
        pageBreadcrumbs.length > 0 &&
        config.pageTitle &&
        config.pageTitle.breadCrumbs && (
          <>
            {/* {config.pageTitle.direction === "row" && (
              <span className="h-20px border-gray-200 border-start mx-3"></span>
            )} */}
            <ul
              className="breadcrumb breadcrumb-separatorless fw-bold my-1"
              style={{ fontSize: "14px" }}
            >
              {Array.from(pageBreadcrumbs).map((item, index, arr) => (
                <li
                  className={clsx("breadcrumb-item", {
                    "text-dark": !item.isSeparator && item.isActive,
                    "text-muted": !item.isSeparator && !item.isActive,
                  })}
                  key={`${item.path}${index}`}
                >
                  {!item.isSeparator ? (
                    <div className="d-flex align-items-center">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.5 2.5L7.5 6L4.5 9.5"
                          stroke="#98A2B3"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>

                      <Link
                        className={`${
                          index === arr.length - 1 ? "" : "text-hover-success"
                        } text-capitalize ms-2`}
                        to={item.path}
                        style={{ color: "#98A2B3" }}
                      >
                        {item.title}
                      </Link>
                    </div>
                  ) : (
                    <span className="bullet bg-gray-200 w-5px h-2px"></span>
                  )}
                </li>
              ))}
              {/* <li className='breadcrumb-item text-dark'>{pageTitle}</li> */}
            </ul>
          </>
        )}
    </div>
  );
};

export { DefaultTitle };
